import { Button } from 'antd';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import React, { useState } from 'react';

export interface ButtonExportProps {
    treeRef: React.RefObject<HTMLDivElement>;
    gantHeaderRef: React.RefObject<HTMLDivElement>;
    gantBodyRef: React.RefObject<HTMLDivElement>;
}

export const ButtonExport: React.FC<ButtonExportProps> = ({ treeRef, gantHeaderRef, gantBodyRef }) => {
    const [inProgress, setInProgress] = useState(false);

    const onClickExport = async () => {
        setInProgress(true);
        setTimeout(async () => {
            try {
                if (!treeRef.current || !gantHeaderRef.current || !gantBodyRef.current) {
                    console.error('One or more target elements not found.');
                    return;
                }

                const treeCanvas = await html2canvas(treeRef.current, { logging: false });
                const headerCanvas = await html2canvas(gantHeaderRef.current, { logging: false });
                const bodyCanvas = await html2canvas(gantBodyRef.current, { logging: false });

                const treeWidth = treeCanvas.width;
                const headerHeight = headerCanvas.height;
                const bodyWidth = bodyCanvas.width;

                const totalWidth = treeWidth + bodyWidth;
                const totalHeight = headerHeight + treeCanvas.height;

                const mergedCanvas = document.createElement('canvas');
                mergedCanvas.width = totalWidth;
                mergedCanvas.height = totalHeight;
                const mergedContext = mergedCanvas.getContext('2d');
                if (!mergedContext) {
                    throw new Error('Could not get 2D context from merged canvas.');
                }

                mergedContext.drawImage(
                    headerCanvas,
                    0,
                    0,
                    headerCanvas.width,
                    headerCanvas.height,
                    treeWidth,
                    0,
                    headerCanvas.width,
                    headerCanvas.height,
                );

                mergedContext.drawImage(
                    bodyCanvas,
                    0,
                    0,
                    headerCanvas.width,
                    treeCanvas.height,
                    treeWidth,
                    headerHeight,
                    headerCanvas.width,
                    treeCanvas.height,
                );

                mergedContext.drawImage(
                    treeCanvas,
                    0,
                    0,
                    treeCanvas.width,
                    treeCanvas.height,
                    0,
                    headerHeight,
                    treeCanvas.width,
                    treeCanvas.height,
                );

                const mergedDataUrl = mergedCanvas.toDataURL('image/png');

                const pdfWidth = mergedCanvas.width * 0.75;
                const pdfHeight = mergedCanvas.height * 0.75;

                const pdf = new jsPDF({
                    orientation: 'landscape',
                    unit: 'pt',
                    format: [pdfWidth, pdfHeight],
                    userUnit: 72,
                });

                pdf.addImage(mergedDataUrl, 'PNG', 0, 0, pdfWidth, pdfHeight);

                pdf.save('export.pdf');
            } catch (error) {
                console.error('Error exporting PDF:', error);
            } finally {
                setInProgress(false);
            }
        }, 1000);
    };

    return (
        <Button loading={inProgress} type="default" onClick={onClickExport}>
            Export PDF
        </Button>
    );
};
